/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 財源区分
 */
export type SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue =
  (typeof SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue)[keyof typeof SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue = {
  特定財源: '特定財源',
  一般財源: '一般財源',
} as const;
